import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../Component/Modal/Modal';
import MUISelect from '../../Component/UI/MUISelect/MUISelect';

const PdfFilterModal = ({
  open,
  onClose,
  pdfFilterOption,
  onFilterChange,
  onDownload,
  pdfFilterOptions
}) => {
  const handleDownload = () => {
    if (pdfFilterOption) {
      onDownload();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      handleClose={onClose}
      title="Download Conversation PDF"
      width="500px"
    >
      <div style={{ padding: '10px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            marginBottom: '20px',
            padding: '12px',
            backgroundColor: '#f0f9ff',
            borderRadius: '8px',
            border: '1px solid #bfdbfe'
          }}
        >
          <FontAwesomeIcon 
            icon={faInfoCircle} 
            style={{ 
              color: '#3b82f6',
              fontSize: '20px',
              marginTop: '2px',
              flexShrink: 0
            }} 
          />
          <Typography 
            variant="body2" 
            style={{ 
              color: '#1e40af', 
              lineHeight: '1.6',
              margin: 0
            }}
          >
            Select which tables you want to include in the PDF download. You can 
            choose to download only Brand tables, only Category tables, or both 
            Brand and Category tables.
          </Typography>
        </Box>

        <MUISelect
          label="Select Tables to Include"
          options={pdfFilterOptions}
          optionValue={pdfFilterOption}
          onChange={onFilterChange}
          fullWidth={true}
          id="pdf-filter-select"
        />

        <div
          style={{
            marginTop: '24px',
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            style={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownload}
            disabled={!pdfFilterOption}
            startIcon={<FontAwesomeIcon icon={faDownload} />}
            style={{ textTransform: 'none' }}
          >
            Download PDF
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PdfFilterModal;